<template>
	<div>
		<v-dialog v-model="dialog_registration_type" no-click-animation scrollable persistent transition="dialog-bottom-transition">
			<v-card>
	        	<!-- v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader>Registration Type</v-subheader>
	        	</v-card-title> -->
	        	<!-- <v-divider></v-divider> -->
		        <v-card-text full-height nopadding>

			        <v-list>
			        	<v-list-tile v-for="(item, index) in registrationTypes" :key="index" @click="fn_updateRegistrationType(item)">

				            <v-list-tile-content>
				              <v-list-tile-title>{{item.name}}</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
						        <v-icon v-if="item.status == selectedRegistrationType">radio_button_checked</v-icon>
						        <v-icon v-else>radio_button_unchecked</v-icon>
				            </v-list-tile-action>

			        	</v-list-tile>
			        </v-list>
		        </v-card-text>
		        <!-- <v-divider></v-divider> -->
		        <!-- <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		        </v-card-actions> -->
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['registrationTypes', 'selectedRegistrationType'],
		data(){
			return{
				dialog_registration_type:false,
				hide_overlay:true
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_registration_type = true;
			},
			closeDialogWeb: function () {
				this.dialog_registration_type = false;
			},
			fn_updateRegistrationType: function(item){
				this.$parent.Form.GSTRegistrationStatus = item.status;
				if(item.status == 1){
                    this.$parent.Form.TaxMode = 1;
                    this.$parent.Form.HSNApplicable = true;
                }
                else{
                    this.$parent.Form.TaxMode = 0;
                    this.$parent.Form.HSNApplicable = false;
                }
				// this.$parent.Form.TaxMode = this.$parent.Form.GSTRegistrationStatus == 1 ? 1 : null;
				this.$parent.fn_closeDialog();
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/registration/dialogs/dialog_registration_types.vue